import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router'
import { AuthProvider } from './auth'
import { RequireSignIn } from './pages/guards'
import { SignInPage } from './pages/SignIn'
import { MfaPage } from './pages/Mfa'
import { InvitePage } from './pages/Invite'
import { HomePage } from './pages/Home'
import { OnboardingPage } from './pages/Onboarding'
import { BusinessLayout } from './pages/business/Layout'
import { TodayPage } from './pages/business/Today'
import { BookingsPage } from './pages/business/Bookings'
import { GuestsPage } from './pages/business/Guests'
import { SettingsPage } from './pages/business/Settings'
import { PlatformPage } from './pages/platform/Platform'
import { AccountPage } from './pages/Account'
import './styles.css'

const router = createBrowserRouter([
  { path: '/sign-in', element: <SignInPage /> },
  { path: '/invite', element: <InvitePage /> },
  {
    element: <RequireSignIn />,
    children: [
      { path: '/', element: <HomePage /> },
      { path: '/mfa', element: <MfaPage /> },
      { path: '/account', element: <AccountPage /> },
      { path: '/onboarding', element: <OnboardingPage /> },
      { path: '/platform', element: <PlatformPage /> },
      {
        path: '/b/:businessId',
        element: <BusinessLayout />,
        children: [
          { index: true, element: <Navigate to="today" replace /> },
          { path: 'today', element: <TodayPage /> },
          { path: 'bookings', element: <BookingsPage /> },
          { path: 'guests', element: <GuestsPage /> },
          { path: 'settings/*', element: <SettingsPage /> },
        ],
      },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
])

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </StrictMode>,
)
